export default __webpack_public_path__ + "static/media/home-image-three.7e76a2f7.jpg";